/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

/*global importUIComponent:true*/
import {
    PolymerElement,
    html
} from "@polymer/polymer/polymer-element.js";
import {
    mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
/**
 * `create-listing` service request element
 * 
 */

class ServiceRequestSummary extends PolymerElement {
    static get properties() {
        return {
            /* Data passed from account page */
            listingdetails: {
                type: Object,
                notify: true
            },
            summarydetails: {
                type: Object,
                notify: true,
                observer: "navigateToDetailsSummary"
            }
        };
    }

    static get template() {
        return html `
      <style include="app-styles"></style>
      <div id="input_element">
        <!-- Input element will attached here -->
      </div>
      <!--<custom-form></custom-form>-->
    `;
    }
    constructor() {
        super();
    }
    ready() {
        super.ready();
        window.PolymerElement = PolymerElement;
        window.html = html;
        window.mixinBehaviors = mixinBehaviors;
    }

    navigateToDetailsSummary() {
        if (this.listingdetails && this.summarydetails) {
            var inputElementDiv = this.shadowRoot.querySelector("#input_element");
            var element = document.createElement(this.summarydetails.templatename);
            element.srdetails = this.listingdetails;
            inputElementDiv.innerHTML = "";
            inputElementDiv.appendChild(element);
            var self = this;
            var url = "/api/UIComponents/component/" + this.summarydetails.templatename;
            self.dispatchEvent(new CustomEvent('start-processing-loader', {
                bubbles: true,
                composed: true
            }));
            importUIComponent(url, function () {
                self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                    bubbles: true,
                    composed: true
                }));
            });
        }
    }

}

customElements.define('service-request-summary', ServiceRequestSummary);